import type { FC } from 'react'
import { CheckCircleIcon } from '@/components/ui/icons'
import { routes } from '@/routes'
import { Trans, useTranslation } from '@/translations/i18n'
import type { SubmitListingResponse } from '../http/luxe-submissions.http'
import { SubmissionFooter } from './submission-footer'
import { SubmissionFormHeader } from './submission-form-header'

interface SubmissionSuccessProps {
	submissionDetails: SubmitListingResponse
}

export const SubmissionSuccess: FC<SubmissionSuccessProps> = ({
	submissionDetails
}) => {
	const { t } = useTranslation()

	return (
		<div className='flex flex-1 flex-col bg-neutral-white'>
			<SubmissionFormHeader />

			<div className='m-6 w-fit flex-1'>
				<div className='mx-auto flex w-auto flex-1 flex-col gap-6 m:rounded-3xl m:border m:border-neutral-300 p-6'>
					<CheckCircleIcon className='text-success-600' size={48} />

					<div className='flex flex-col gap-2'>
						<h2 className='font-bold text-neutral-900 text-xl'>
							{t('luxe_submissions:submission_successful')}
						</h2>
						<p className='text-neutral-900'>
							<Trans
								components={{
									b: <strong />
								}}
								i18nKey='luxe_submissions:submission_successful_description'
								values={{
									submissionName:
										submissionDetails.listingName
								}}
							/>
						</p>
					</div>

					<div className='grid grid-cols-3 rounded-3xl bg-neutral-50 px-2 py-4'>
						<div className='flex flex-col gap-1 px-3 py-1.5'>
							<span className='text-neutral-600 uppercase'>
								{t('luxe_submissions:listing', { count: 1 })}
							</span>
							<p className='font-medium text-neutral-700'>
								{submissionDetails.listingName}
							</p>
						</div>

						<div className='flex flex-col gap-1 px-3 py-1.5'>
							<span className='text-neutral-600 uppercase'>
								{t('luxe_submissions:submission_id')}
							</span>
							<p className='font-medium text-neutral-700'>
								#
								{submissionDetails.airbnbListingId ??
									submissionDetails.id}
							</p>
						</div>

						{submissionDetails.externalHostId && (
							<div className='flex flex-col gap-1 px-3 py-1.5'>
								<span className='text-neutral-600 uppercase'>
									{t('luxe_submissions:host_id')}
								</span>
								<p className='font-medium text-neutral-700'>
									#{submissionDetails.externalHostId}
								</p>
							</div>
						)}
					</div>
				</div>
			</div>

			<SubmissionFooter
				label={t('luxe_submissions:submit_another_listing')}
				to={routes.LUXE_SUBMISSIONS_SUBMISSION.handle.fullPath}
			/>
		</div>
	)
}
